export default "/images/419dbcd75019cac507261801373bc15a.avif";